<template>
  <div
    class="m-nav"
    :class="{
      'm-nav--grow': grow,
    }"
  >
    <ul
      class="m-nav__list"
      itemscope
      itemtype="http://www.schema.org/SiteNavigationElement"
    >
      <slot />
    </ul>
  </div>
</template>

<script lang="ts">
/**
 * The main site navigation, sits in the site header layout
 */
export default {
  name: 'MNav',
  props: {
    /**
     * Expand the nav to fit its flex
     * container
     */
    grow: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.m-nav {
  align-items: center;
  display: grid;
  height: 100%;

  &__list {
    align-items: center;
    display: flex;
    height: 100%;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  &--grow {
    flex: 1 1 auto;
  }
}
</style>
